@if (partner$ | async; as partner) {
  <pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
  <div class="border-b border-solid border-slate-300"></div>

  <div class="wrapper">
    <div fxLayout="column" fxLayoutGap="16px" class="layout-margin">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between start"
        fxLayoutGap="16px"
      >
        <div fxFlex class="info mat-body-1">
          <p>Name: {{ partner.name }}</p>
          <p>Regions: {{ partner | map: getRegions }}</p>
          <p>
            Joined:
            {{ partner.createdAt | moment | amDateFormat: dateFormat }}
          </p>
        </div>
        <div class="flex items-center gap-4">
          <pr-partner-status [status]="partner.status" />
          <pr-partner-actions [partner]="partner" />
        </div>
      </div>

      <h2 class="mat-headline-6">Links</h2>
      <mat-nav-list>
        <a mat-list-item [routerLink]="['./users']">Users</a>
      </mat-nav-list>
    </div>
  </div>
}
